import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextEditor } from '../../ui/TextEditor';

interface Props {
  disabled?: boolean;
}

export const LocationDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.locationdetails.fields.locationDescription.label')}
      fieldName="descriptions.locationDetails"
      placeholder={t('dashboard.assets.addedit.main.locationdetails.fields.locationDescription.placeholder')}
    />
  );
};
